import { useCallback, useState } from 'react';
import type { ToastType } from '@/components/Toast';

interface UseToastReturn {
  showToast: (message: string, type: ToastType) => void;
  toast: { message: string; type: ToastType; isVisible: boolean };
  hideToast: () => void;
}

export function useToast(): UseToastReturn {
  const [toast, setToast] = useState({
    message: '',
    type: 'success' as ToastType,
    isVisible: false,
  });

  const showToast = useCallback((message: string, type: ToastType) => {
    setToast({ message, type, isVisible: true });
  }, []);

  const hideToast = useCallback(() => {
    setToast((previous) => ({ ...previous, isVisible: false }));
  }, []);

  return { showToast, toast, hideToast };
}
